/* tslint:disable */
/* eslint-disable */
/**
 * CarePlatform User Preferences API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: jonas.malik@magello.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    UserLocaleType,
    UserLocaleTypeFromJSON,
    UserLocaleTypeFromJSONTyped,
    UserLocaleTypeToJSON,
    UserVideoBackgroundType,
    UserVideoBackgroundTypeFromJSON,
    UserVideoBackgroundTypeFromJSONTyped,
    UserVideoBackgroundTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface UserPreferencesResponse
 */
export interface UserPreferencesResponse {
    /**
     * The UUID of this user
     * @type {string}
     * @memberof UserPreferencesResponse
     */
    userId: string;
    /**
     * 
     * @type {UserLocaleType}
     * @memberof UserPreferencesResponse
     */
    locale: UserLocaleType;
    /**
     * 
     * @type {UserVideoBackgroundType}
     * @memberof UserPreferencesResponse
     */
    videoBackgroundType: UserVideoBackgroundType;
    /**
     * The UUID of the file
     * @type {string}
     * @memberof UserPreferencesResponse
     */
    videoBackgroundFileId?: string;
    /**
     * Date and time this user was created
     * @type {Date}
     * @memberof UserPreferencesResponse
     */
    createdOn?: Date;
    /**
     * Date and time this user was last updated
     * @type {Date}
     * @memberof UserPreferencesResponse
     */
    updatedOn?: Date;
}

export function UserPreferencesResponseFromJSON(json: any): UserPreferencesResponse {
    return UserPreferencesResponseFromJSONTyped(json, false);
}

export function UserPreferencesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPreferencesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'locale': UserLocaleTypeFromJSON(json['locale']),
        'videoBackgroundType': UserVideoBackgroundTypeFromJSON(json['videoBackgroundType']),
        'videoBackgroundFileId': !exists(json, 'videoBackgroundFileId') ? undefined : json['videoBackgroundFileId'],
        'createdOn': !exists(json, 'createdOn') ? undefined : (new Date(json['createdOn'])),
        'updatedOn': !exists(json, 'updatedOn') ? undefined : (new Date(json['updatedOn'])),
    };
}

export function UserPreferencesResponseToJSON(value?: UserPreferencesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userId': value.userId,
        'locale': UserLocaleTypeToJSON(value.locale),
        'videoBackgroundType': UserVideoBackgroundTypeToJSON(value.videoBackgroundType),
        'videoBackgroundFileId': value.videoBackgroundFileId,
        'createdOn': value.createdOn === undefined ? undefined : (value.createdOn.toISOString()),
        'updatedOn': value.updatedOn === undefined ? undefined : (value.updatedOn.toISOString()),
    };
}


